import React, { useState, useEffect } from "react";
import AuthService from "../services/auth.service";
import atmos_logo from "../image/atmos-logo.jpg";
import logout_icon from "../image/logout-icon.png";
import { Link, NavLink } from "react-router-dom";
import Popup from "reactjs-popup";
import DownloadData from "../component/DownloadData";
import download_white_icon from "../image/download-white-icon.png";

function Navbar(props) {
  const [currentUser, setCurrentUser] = useState(undefined);

  const logOut = () => {
    AuthService.logout();
    window.location.reload();
  };

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);
    }
  }, []);
  return (
    <div className="navbar-head">
      <nav className="navbar navbar-expand ">
        <Link to={"/atmos/"} className="navbar-brand">
          <img src={atmos_logo} alt="atmoslogo" height="62px" />
        </Link>

        {localStorage.getItem("check_calibration") === "1" && (
          <div className="navbar-nav">
            <li className="nav-item">
              <NavLink
                to={"/atmos/chart"}
                activeClassName="active"
                className="nav-link nav-button px-0"
              >
                <span className="nav-button-text">Chart</span>
              </NavLink>
            </li>
          </div>
        )}

        {currentUser && (
          <div className="navbar-nav mr-auto">
            <li className="nav-item">
              <NavLink
                to={"/atmos/map"}
                activeClassName="active"
                className="nav-link nav-button px-0"
              >
                <span className="nav-button-text">Map</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to={"/atmos/table"}
                activeClassName="active"
                className="nav-link nav-button px-0"
              >
                <span className="nav-button-text">Table</span>
              </NavLink>
            </li>
            <Popup
              trigger={
                <button className="download-popup-button">
                  <img src={download_white_icon} alt="download" width="25px" />
                </button>
              }
            >
              {(close) => (
                <div className="overlay">
                  <div className="custom-download-data">
                    <a className="close" onClick={close}>
                      &times;
                    </a>
                    <DownloadData data1={props.data1} />
                  </div>
                </div>
              )}
            </Popup>
          </div>
        )}

        {currentUser && (
          <div className="navbar-nav ml-auto">
            <div className="btn-group nav-link px-0">
              <button
                type="button"
                className="profile-pic dropdown-toggle"
                // data-toggle="dropdown"
                // aria-haspopup="true"
                // aria-expanded="false"
              >
                <img
                  src={localStorage.getItem("logo")}
                  height="50px"
                  alt="logo"
                />
              </button>
              {/* <div className="dropdown-menu">
                <NavLink to={"/atmos/user"} className="dropdown-item">
                  User
                </NavLink>
                <div className="dropdown-divider"></div> */}
              {/* <NavLink
                  to={"/atmos/login"}
                  className="dropdown-item"
                  onClick={logOut}
                >
                  Logout
                </NavLink> */}
              {/* </div> */}
            </div>
            <div>
              <p className="user-name">{localStorage.getItem("username")}</p>
              <p className="email-address">{localStorage.getItem("email")}</p>
            </div>

            <p className="verticle-line"></p>
            <NavLink
              to={"/atmos/login"}
              style={{ marginRight: "15px", alignSelf: "center" }}
              onClick={logOut}
            >
              <img src={logout_icon} height="50px" alt="Logout" />
            </NavLink>
          </div>
        )}
      </nav>
    </div>
  );
}

export default Navbar;
